import { combineReducers } from "redux";
import { reducer as toastrReducer } from "react-redux-toastr";
import { authentication } from "./authentication.reducer";
import { searchData } from "./searchData.reducer";
import { searchEmailData } from "./emailData.reducer";
import { reducer as oidcReducer } from "redux-oidc";
import loginReducer from "./loginReducer.js";
import { spinner } from "./spinner.reducer";
import { connectRouter } from "connected-react-router";
import { history } from "../helpers";
import auditorReducer from "./auditorReducer.js";

console.log("history:--", history);
const rootReducer = combineReducers({
  router: connectRouter(history),
  //authentication,
  searchEmailData,
  searchData,
  oidc: oidcReducer,
  toastr: toastrReducer,
  loginReducer,
  spinner,
  auditorReducer,
});

export default rootReducer;

// import { combineReducers } from 'redux';
// import {reducer as toastrReducer} from 'react-redux-toastr';
// import { authentication } from './authentication.reducer';
// import { searchData } from './searchData.reducer';
// import { reducer as oidcReducer } from 'redux-oidc';
// import loginReducer from './loginReducer.js';
// import { spinner } from './spinner.reducer';
// import { connectRouter } from 'connected-react-router';
// import { history } from '../helpers';

// console.log('history:--',history);
// const rootReducer= combineReducers({
// 	router: connectRouter(history),
// 	//authentication,
// 	  searchData,
// 	oidc: oidcReducer,
// 	toastr: toastrReducer,
// 	loginReducer,
// 	spinner
// })

// export default rootReducer;
